import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {
	AttributeType,
	ConfigurationInterpreter,
	DecisionKind
} from '@viamedici-spc/configurator-ts';

import {SpcBaseAttribute} from './spcBaseAttribute';
import {attributeIdToString} from './util/spcUtils';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';
import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';

@customElement('spc-boolean-attribute')
export class SpcBooleanAttribute extends SpcBaseAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {
			}
		`];

	stateChanged(state) {
		super.stateChanged(state);

		if (this.spcConfiguration) {
			this.attribute = ConfigurationInterpreter.getBooleanAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				const selectedValue = this.attribute.decision?.state === true
					? 'true' : this.attribute.decision?.state === false ? 'false' : '';
				this.isIncludedStatePossible = this.attribute.possibleDecisionStates.includes(true);
				this.isExcludedStatePossible = this.attribute.possibleDecisionStates.includes(false);
				this.falseValue = {
					id: false,
					name: 'no', //TODO: translate component value id
					isImplicit: this.attribute.decision?.state === false && this.attribute.decision?.kind === DecisionKind.Implicit
				};
				this.trueValue = {
					id: true,
					name: 'yes', //TODO: translate
					isImplicit: this.attribute.decision?.state === false && this.attribute.decision?.kind === DecisionKind.Implicit
				};
			} else {
				console.error('Component attribute not found with id', this.attributeId, this.spcConfiguration);
			}
		}
	}
	async resetDecision() {
		this.session.makeDecision({
			type: AttributeType.Boolean,
			attributeId: this.attribute.id,
			state: null
		});
	}
	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}
	render() {
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
					<span class="label">${attributeIdToString(this.attributeId)}</span>
					<div class="tools">
						<button class='tools_button' @click="${this.showInfo}"><span class="icon">${info}</span></button>
						<button class='tools_button' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
					</div>
				</div>
				<div class="values">
					<spc-boolean-value
						.attributeId=${this.attributeId}
						.value=${this.trueValue}
						.hideDisabled=${this.hideDisabled}
						.productData=${this.getProductDataForValue(this.trueValue.id)}>
					</spc-boolean-value>
					<spc-boolean-value
						.attributeId=${this.attributeId}
						.value=${this.falseValue}
						.hideDisabled=${this.hideDisabled}
						.productData=${this.getProductDataForValue(this.falseValue.id)}>
					</spc-boolean-value>
				</div>
			</div>

		`;
	}
}
